import SectionHeading from "./SectionHeading";
import { processSteps } from "@/mocks/home";

export default function ProcessSection() {
  return (
    <section id="process" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="投稿流程"
            title="一条爆料从提交到发布，会经历什么"
            desc="四个环节全程可追踪，每一步都有明确的处理时限，你不用担心线索提交后石沉大海。"
          />
          <a
            href="#submit"
            className="hidden lg:inline-flex items-center gap-2 px-5 py-3 rounded-md border border-foreground-300 text-foreground-700 text-sm whitespace-nowrap hover:border-primary-400 hover:text-primary-700 transition-colors"
          >
            跳过阅读，直接投稿
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {processSteps.map((step, index) => (
            <article
              key={step.step}
              className="relative flex flex-col p-6 rounded-lg bg-background-50 border border-background-200"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 rounded-md flex items-center justify-center bg-primary-100 text-primary-700">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <span className="font-heading font-black text-3xl text-background-300">
                  {step.step}
                </span>
              </div>
              <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed flex-1">
                {step.desc}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-xs text-secondary-700 bg-secondary-100 rounded-full px-3 py-1.5 self-start">
                <i className="ri-time-line"></i>
                {step.time}
              </span>
              {index < processSteps.length - 1 && (
                <i className="hidden lg:block ri-arrow-right-line text-2xl text-background-300 absolute top-1/2 -right-[26px] -translate-y-1/2"></i>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}